import { render, staticRenderFns } from "./CoursesDialogue.vue?vue&type=template&id=9395b79e&scoped=true&"
import script from "./CoursesDialogue.vue?vue&type=script&lang=js&"
export * from "./CoursesDialogue.vue?vue&type=script&lang=js&"
import style0 from "./CoursesDialogue.vue?vue&type=style&index=0&id=9395b79e&lang=scss&scoped=true&"
import style1 from "./CoursesDialogue.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9395b79e",
  null
  
)

export default component.exports